import { getRemoteConfig } from 'firebase/remote-config';
import { put, takeLatest } from 'redux-saga/effects';

import { apiClient, getApiEndpoint } from '../tools/tools';
import { GET_DELIVERY_REQUEST, SET_DELIVERY } from './delivery.action';

const FALLBACK_MIN_FEE = 10;

async function fetchDeliveryConfig(apiUrl) {
  const response = await apiClient.get(`${apiUrl}/delivery/config`);
  return response.data;
}

async function fetchDistanceKm(apiUrl, lat, lng) {
  const response = await apiClient.get(`${apiUrl}/delivery/distance`, {
    params: { lat, lng }
  });
  return response.data;
}

function calculateFee(config, distanceKm) {
  const { pricingMode, flatFee, pricePerKm, minFee, maxFee } = config;

  let fee;

  switch (pricingMode) {
    case 'FLAT_FEE':
      fee = parseFloat(flatFee);
      break;
    case 'BASE_PLUS_PER_KM':
      fee = parseFloat(flatFee) + distanceKm * parseFloat(pricePerKm);
      break;
    case 'PER_KM':
    default:
      fee = distanceKm * parseFloat(pricePerKm);
      break;
  }

  if (minFee != null && fee < parseFloat(minFee)) fee = parseFloat(minFee);
  if (maxFee != null && fee > parseFloat(maxFee)) fee = parseFloat(maxFee);

  return fee;
}

function* getDelivery({ destinationLat, destinationLng, onComplete }) {
  let fallbackFee = FALLBACK_MIN_FEE;

  try {
    const remoteConfig = getRemoteConfig();
    const apiUrl = yield getApiEndpoint(remoteConfig);

    const config = yield fetchDeliveryConfig(apiUrl);

    if (config.minFee != null) fallbackFee = parseFloat(config.minFee);

    if (config.pricingMode === 'FLAT_FEE') {
      const deliveryFee = calculateFee(config, 0);
      yield put({ type: SET_DELIVERY, delivery: deliveryFee, distanceKm: 0, error: undefined });
      onComplete?.(null, { deliveryFee, distanceKm: 0 });
      return;
    }

    const distanceKm = yield fetchDistanceKm(apiUrl, destinationLat, destinationLng);
    const deliveryFee = calculateFee(config, distanceKm);

    yield put({ type: SET_DELIVERY, delivery: deliveryFee, distanceKm, error: undefined });
    onComplete?.(null, { deliveryFee, distanceKm });
  } catch (error) {
    yield put({ type: SET_DELIVERY, delivery: fallbackFee, distanceKm: 0, error });
    onComplete?.(error);
  }
}

export default function* watchDelivery() {
  yield takeLatest(GET_DELIVERY_REQUEST, getDelivery);
}
